import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';

/**
 * Shared auth helpers for platform integration settings pages.
 * Supports cookie session (no localStorage token) and bearer tokens.
 */
export function usePlatformIntegrationAuth() {
  const { token, loading: authLoading, isAuthenticated, getAuthHeaders } = useAuth();

  const requestConfig = useCallback(
    () => ({
      headers: token ? { Authorization: `Bearer ${token}` } : getAuthHeaders(),
      withCredentials: true,
    }),
    [token, getAuthHeaders]
  );

  const canFetch = !authLoading && isAuthenticated;

  return {
    token,
    authLoading,
    isAuthenticated,
    getAuthHeaders,
    requestConfig,
    canFetch,
  };
}
